import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {postData, postFile, updateData, deleteItem} from './constants.js';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const moment = require('moment');

class EventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
      show          :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileSubmit = this.handleFileSubmit.bind(this);
    this.addEvent = this.addEvent.bind(this);
    this.editEvent = this.editEvent.bind(this);
    this.uploadEvent = this.uploadEvent.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.viewEvent = this.viewEvent.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  async getEvents() {
    try {
      const response = await fetch('/api/events');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getEvents();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFileChange(event){
    this.setState({
      "filename": event.target.files[0].name
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    delete data.data;
    delete data.isLoading;
    if(data.id){
      updateData('/api/event/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getEvents();
      });
    }else{
      postData('/api/event', data)
        .then((response) => {
          console.log(response);
          this.getEvents();
      });
    }
  }

  handleFileSubmit(event) {
    event.preventDefault();
    this.setState({ show_content: "view", isLoading: true });
    var formData = new FormData();
    var file = document.getElementById("inputGroupFile03").files[0];
    formData.append('File', file);
    var eventId = this.state.id;

    postFile('/api/event_upload/'+eventId, formData)
      .then((response) => {
        console.log(response);
        this.getEvents();
    });
  }

  addEvent() {
    this.setState({
      id            :"",
      title         :"",
      organizers    :"",
      venue         :"",
      map_location  :"",
      start_time    :"",
      end_time      :"",
      contact_person:"",
      contact_phone :"",
      status        :"1",
      description   :"",
      contact_person_position :"",
      show_content  :"form",
      show          :true
    });
  }

  viewEvent(e) {
    const id = parseInt(e.target.id);
    const events = this.state.data;
    const selectedEvent = events.filter(e=> e.id === id)[0];
    this.setState(selectedEvent);
    this.setState({ show: true, show_content: "view" });
  }

  editEvent(e) {
    const id = parseInt(e.target.id);
    const events = this.state.data;
    const selectedEvent = events.filter(e=> e.id === id)[0];
    this.setState(selectedEvent);
    this.setState({ show: true, show_content: "form" });
  }

  uploadEvent(e) {
    const id = parseInt(e.target.id);
    const events = this.state.data;
    const selectedEvent = events.filter(e=> e.id === id)[0];
    this.setState(selectedEvent);
    this.setState({ show: false, show_content: "fileform", filename: "" });
  }

  deleteEvent(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/event/"+id)
    .then((response) => {
      console.log(response);
      this.getEvents();
    });
  }

  render() {
    if(!this.state.isLoading){
      const events = this.state.data;
      const event_list = events.map((event)=>
          <tr key={event.id} id={event.id}>
            <td>{moment(event.start_time, "YYYY-MM-DD HH:mm:ss").format("LLL")}</td>
            <td>{event.title}</td>
            <td className={event.status?'text-success fw-bold':'fw-bold'}>{event.status?'Active':'Inactive'}</td>
            <td>
              <div className="row no-gutters">
                <div className="col">
                  <i id={event.id} className="fas fa-file-upload text-secondary action-icons" onClick={this.uploadEvent}></i>
                </div>
                <div className="col">
                  <i id={event.id} className="fas fa-info-circle text-info action-icons" onClick={this.viewEvent}></i>
                </div>
                <div className="col">
                  <i id={event.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editEvent}></i>
                </div>
                <div className="col">
                  <i id={event.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteEvent}></i>
                </div>
              </div>
            </td>
          </tr>
      );
      return(
          <>
            {this.state.show?(
              <div className="container-fluid">
                {this.state.show_content==="view"?(
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-white">Event details</h4>
                        </div>
                        <div className="card-body event-view">
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Event Title</span>
                            </div>
                            <div className="col-md-10">
                              <span className="font-weight-bold text-dark"> {this.state.title} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Event Start's On </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {moment(this.state.start_time, "YYYY-MM-DD HH:mm:ss").format("LLL")} </span>
                            </div>
                            <div className="col-md-2">
                              <span>End's On </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {moment(this.state.end_time, "YYYY-MM-DD HH:mm:ss").format("LLL")} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Venue </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {this.state.venue} </span>
                            </div>
                            <div className="col-md-2">
                              <span>Location </span>
                            </div>
                            <div className="col-md-4">
                              <span className="text-primary"> {this.state.map_location} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Organizers </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {this.state.organizers} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Contact Person </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {this.state.contact_person} </span>
                            </div>
                            <div className="col-md-2">
                              <span>Position </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {this.state.contact_person_position} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Contact Phone </span>
                            </div>
                            <div className="col-md-4">
                              <span className="font-weight-bold text-dark"> {this.state.contact_phone} </span>
                            </div>
                            <div className="col-md-2">
                              <span>Status </span>
                            </div>
                            <div className="col-md-4">
                              <span className={this.state.status?'fw-bold text-success':'fw-bold'}> {this.state.status?"Active":"Inactive"} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col">
                              <span>Description </span>
                              <div>
                                <span dangerouslySetInnerHTML={{ __html: this.state.description }}></span>
                              </div>
                            </div>
                          </div>
                          <div className="mt-2">
                            {this.state.file_url?
                              <>
                                <a target="_blank" href={this.state.file_url} className="text-primary fw-bold">View Event File</a>
                              </>:
                              <></>
                            }
                            <button className="btn btn-danger float-right" onClick={()=>this.setState({show:false})}> Close </button>
                          </div>
                        </div>
                    </div>
                ):(
                  <>
                  {this.state.show_content==="form" &&
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-light">Add / Edit Event</h4>
                        </div>
                        <div className="card-body event-form">
                            <form id="eventForm" className="user" onSubmit={this.handleSubmit} autoComplete="off">
                              <div className="row">
                                <div className="col-xs-12 col-md-6">
                                  <label>Event Title</label>
                                  <input type="text" className="form-control" name="title" value={this.state.title} onChange={this.handleInputChange} required />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <label>Organizers </label>
                                  <input type="text" className="form-control" name="organizers" value={this.state.organizers} onChange={this.handleInputChange} required />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-xs-12 col-md-6">
                                  <label>Venue </label>
                                  <input type="text" className="form-control" name="venue" value={this.state.venue} onChange={this.handleInputChange} required />
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label>Start Time</label>
                                  <input type="datetime-local" 
                                    step="60" 
                                    className="form-control" 
                                    name="start_time"
                                    value={moment(this.state.start_time, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm")}
                                    pattern="\d{4}-\d{2}-\d{2}T(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)"
                                    onChange={this.handleInputChange} 
                                    required />
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label>End Time</label>
                                  <input type="datetime-local" className="form-control" name="end_time"
                                   value={moment(this.state.end_time, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm")}
                                   pattern="\d{4}-\d{2}-\d{2}T(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)"
                                   onChange={this.handleInputChange} required />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-xs-12 col-md-6">
                                  <label>Contact Person</label>
                                  <input type="text" className="form-control" name="contact_person" value={this.state.contact_person} onChange={this.handleInputChange} required />
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label>Contact's Position </label>
                                  <input type="text" className="form-control" name="contact_person_position" value={this.state.contact_person_position} onChange={this.handleInputChange} required />
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label>Contact Phone </label>
                                  <input type="text" className="form-control" name="contact_phone" value={this.state.contact_phone} onChange={this.handleInputChange} required />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-xs-12 col-md-6">
                                  <label>Map Location Ref </label>
                                  <input type="text" className="form-control" name="map_location" value={this.state.map_location} onChange={this.handleInputChange} />
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label> Description </label>
                                  <button type="button" id="editor-open" className="btn btn-block btn-outline-success" data-toggle="modal" data-target="#eventModalbox"> Open Text-editor</button>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                  <label>Registrations </label>
                                  <select className="form-select" name="status" value={this.state.status} onChange={this.handleInputChange}>
                                    <option value={0}> Inactive </option>
                                    <option value={1}> Active </option>
                                  </select>
                                </div>
                              </div>
                              <div className="form-group mt-2">
                                <input type="submit" id="event-submit" className="btn btn-bg-success" value="Submit" />
                                <button type="button" name="cancel" className="btn btn-danger float-right" onClick={()=> this.setState({show:false})}>Cancel</button>
                              </div>
                              <>
                                <div className="modal fade" id="eventModalbox" role="dialog" aria-labelledby="exampleModalLabel"
                                    aria-hidden="true">
                                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title" id="exampleModalLabel">Event Description </h4>
                                                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                              <CKEditor
                                                  editor={ ClassicEditor }
                                                  data={this.state.description}
                                                  onReady={ editor => {
                                                      editor.editing.view.change((writer) => {
                                                        writer.setStyle(
                                                          "height",
                                                          "380px",
                                                          editor.editing.view.document.getRoot()
                                                        );
                                                      });
                                                      // You can store the "editor" and use when it is needed.
                                                      console.log( 'Editor is ready to use!', editor );
                                                  }}
                                                  onChange={ ( event, editor ) => {
                                                      const data = editor.getData();
                                                      this.setState({ description: data });
                                                      console.log( { event, editor, data } );
                                                  }}
                                              />
                                            </div>
                                            <div className="modal-footer">
                                                <small className="text-primary text-bold"> Your changes will be automatically saved. </small>
                                                <button className="btn btn-sm btn-secondary" type="button" data-dismiss="modal">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </>
                            </form>
                        </div>
                    </div>
                  }
                  </>
                )}
              </div>
            ):(
              <div className="row">
                  <div className="col-lg-8 col-md-7 col-xs-12">
                      <div className="card shadow mb-2">
                          <div className="card-header py-3">
                              <h4 className="m-0 font-weight-bold text-white">Events</h4>
                          </div>
                          <div className="card-body">
                              <div className="table-responsive event-table">
                                  <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                      <thead>
                                          <tr>
                                              <th>Date</th>
                                              <th>Title</th>
                                              <th>Status</th>
                                              <th></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {event_list}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                      <button className="btn btn-primary" onClick={this.addEvent}><i className="fas fa-plus"></i> New Event</button>
                  </div>
                  <div className="col-lg-4 col-md-5 col-xs-12">
                   {this.state.show_content==="fileform" &&
                      <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h4 className="m-0 font-weight-bold text-light">{this.state.title}</h4>
                            </div>
                            <div className="card-body">
                                <form className="user" onSubmit={this.handleFileSubmit} autoComplete="off">
                                    <div className="form-group">
                                      <label>Upload a Event File </label>
                                      <div className="input-group">
                                          <div className="custom-file">
                                             <input type="file" className="custom-file-input" id="inputGroupFile03" onChange={this.handleFileChange}  aria-describedby="inputGroupFileAddon04" />
                                             <label className="custom-file-label" for="inputGroupFile03">Choose File</label>
                                          </div>
                                      </div>
                                      <p className="text-success">{this.state.filename}</p>
                                    </div>
                                    <div className="form-group">
                                      <input type="submit" id="album-submit" className="btn btn-bg-success" value="Submit" />
                                      <button type="button" name="cancel" className="btn btn-danger float-right" onClick={()=> this.setState({show_content:'view'})}>Cancel</button>
                                    </div>
                                    {this.state.file_url?
                                      <>
                                        <embed src={this.state.file_url} height="250" width="300" />
                                      </>:<></>
                                    }
                                </form>
                            </div>
                      </div>
                    }
                  </div>
              </div>
            )}
          </>
      );
    }
  }
}

function Events() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <EventList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Events };
